export const LICENSE_EXPIRED_ERROR_CODE = "LICENSE_EXPIRED" as const;
export const LICENSE_EXPIRED_RETURN_PATH_KEY =
  "license_expired_return_path" as const;
